import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNakaLaData } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";
import FinListNakalaKafla from "./FinListNakalaKafala";

export default function FinNakalaKafala() {
  const nakaData = useSelector((state) => state.nakaLaData);
  const dispatch = useDispatch();
  //screen Title Show fun
  const titleBorder = [
    { label: "Nakal Kafala Fee", link: "/dashboard/NakalaKafala" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getNakaLaData(token));
  }, []);

  const callBack = () => {
    dispatch(getNakaLaData(token));
  };

  return (
    <>
      <div className={`ml-5 mr-5`}>
        <FinListNakalaKafla
          list={nakaData}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE NAME",
            "CLIENT",
            "VISA SPONSOR (INITIAL)",
            "IQAMA NUMBER",
            "PASSPORT NUMBER",
            "IQAMA PROFESSSION",
            // "CURRENT PROFESSION LEVEL",
            "Application Date",
            "VISA SPONSOR (CURRENT)",
            "CHANGE FEE",
            "BORNE BY",
            "NAKAL KAFALA FEE",
            "SUB SEGMENT",
            "status",
            "",
          ]}
          token={token}
          updateData={callBack}
        />
      </div>
    </>
  );
}
